import {
  LeasePaymentDetails,
  PaymentRecord,
  WalletStatementCardProps,
} from "@/types/lease-journey";
import { createSlice } from "@reduxjs/toolkit";
const initialState: {
  paymentsRecords: LeasePaymentDetails;
  statementsData: WalletStatementCardProps;
  paymentsData: PaymentRecord;
  loading: boolean;
  isInvoiceFlow: boolean;
} = {
  paymentsRecords: {
    leaseDocDetails: {
      paymentType: "",
      paymentTypeDesc: "",
      subGroupType: "",
      subGroupDesc: "",
      compGroup: "",
      companyCode: "",
      companyDesc: "",
      docNumber: "",
      postYear: "",
      dueDate: "",
      paymentDate: "",
      amount: "",
      paymentMethod: "",
      paymentTime: "",
    },
    breakupDetails: [],
  },
  statementsData: {
    price: 0,
    label: "",
    unitNumber: "",
    location: "",
    date: "",
    id: "",
    docId: "",
    docType: "",
    companyCode: "",
    receiptYear: "",
    invoiceId: "",
    dueDate: "",
    imageUrl: ""
  },
  paymentsData: {
    id: "",
    sourceType: "",
    unit: "",
    externalUnitId: "",
    leaseId: "",
    paymentType: "",
    paymentTypeDesc: "",
    companyCode: "",
    companyDesc: "",
    docId: "",
    receiptYear: "",
    paymentDate: "",
    dueDate: "",
    invoiceId: "",
    invoiceCompCode: "",
    invoiceYear: "",
    amount: 0,
    status: "",
    docType: "",
    currency: "",
    docStatus: "",
    groupType: "",
    paymentDueDate: "",
  },
  loading: true,
  isInvoiceFlow: false,
};

const leasePaymentsSlice = createSlice({
  name: "leasePaymentsReducer",
  initialState: { ...initialState },
  reducers: {
    setPaymentRecordsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setInvoiceFlow: (state, action) => {
      state.isInvoiceFlow = action.payload;
    },
    setLeasePaymentsRecordsDetails: (state, action): any => {
      state.paymentsRecords = action.payload;
      state.loading = false;
    },
    setLeaseStatementsDetails: (state, action): any => {
      state.statementsData = action.payload;
    },
    setLeasePaymentsDetails: (state, action): any => {
      state.paymentsData = action.payload;
    },
    reSetLeasePaymentsPayments: (state: any): any => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  setLeasePaymentsRecordsDetails,
  reSetLeasePaymentsPayments,
  setPaymentRecordsLoading,
  setInvoiceFlow,
  setLeaseStatementsDetails,
  setLeasePaymentsDetails
} = leasePaymentsSlice.actions;
export default leasePaymentsSlice.reducer;
